import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

/** @param {{ rows: Array<{ quantity?: string, description?: string }>, onChange: (rows: Array<{ quantity?: string, description?: string }>) => void, disabled?: boolean }} props */
export default function AlaCarteDeliverableRowsEditor({ rows, onChange, disabled }) {
  const list = Array.isArray(rows) && rows.length > 0 ? rows : [{ quantity: '', description: '' }];

  const update = (index, field, value) => {
    const next = list.map((r, i) => (i === index ? { ...r, [field]: value } : r));
    onChange(next);
  };

  const addRow = () => {
    onChange([...list, { quantity: '', description: '' }]);
  };

  const removeRow = (index) => {
    if (list.length <= 1) {
      onChange([{ quantity: '', description: '' }]);
      return;
    }
    onChange(list.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-2">
      <div className="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-600">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 dark:bg-gray-700/80">
            <tr>
              <th className="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-200">Quantity</th>
              <th className="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-200">Description</th>
              <th className="w-10 px-2 py-2" aria-hidden />
            </tr>
          </thead>
          <tbody>
            {list.map((row, index) => (
              <tr key={index} className="border-t border-gray-100 dark:border-gray-600">
                <td className="px-3 py-2 align-top">
                  <input
                    type="text"
                    disabled={disabled}
                    value={row.quantity ?? ''}
                    onChange={(e) => update(index, 'quantity', e.target.value)}
                    className="w-full rounded border border-gray-300 bg-white px-2 py-1.5 text-gray-900 dark:border-gray-600 dark:bg-gray-800 dark:text-white disabled:opacity-60"
                    placeholder="e.g. 4"
                  />
                </td>
                <td className="px-3 py-2 align-top">
                  <textarea
                    disabled={disabled}
                    value={row.description ?? ''}
                    onChange={(e) => update(index, 'description', e.target.value)}
                    rows={2}
                    className="w-full rounded border border-gray-300 bg-white px-2 py-1.5 text-gray-900 dark:border-gray-600 dark:bg-gray-800 dark:text-white disabled:opacity-60"
                    placeholder="Deliverable description"
                  />
                </td>
                <td className="px-2 py-2 align-top">
                  <button
                    type="button"
                    disabled={disabled}
                    onClick={() => removeRow(index)}
                    className="rounded p-1.5 text-red-600 hover:bg-red-50 disabled:opacity-40 dark:hover:bg-red-900/30"
                    aria-label="Remove row"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        type="button"
        disabled={disabled}
        onClick={addRow}
        className="inline-flex items-center gap-1 text-sm font-medium text-red-600 hover:text-red-700 disabled:opacity-50 dark:text-red-400"
      >
        <Plus className="h-4 w-4" />
        Add row
      </button>
    </div>
  );
}
